import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { LoadingController } from 'ionic-angular';

import { NewRegistrationExistsPage } from '../new-registration-exists/new-registration-exists';
import { NewRegistrationStep2Page } from '../new-registration-step2/new-registration-step2';

import { ValidatorProvider } from '../../providers/validator/validator';
import { AlertProvider } from '../../providers/alert/alert';
import { AuthProvider } from '../../providers/auth/auth';
import { NewRegistrationProvider } from '../../providers/new-registration/new-registration';

import { NewRegistration } from '../../models/newregistration';

/**
 * Generated class for the NewRegistrationStep1Page page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-new-registration-step1',
  templateUrl: 'new-registration-step1.html',
})
export class NewRegistrationStep1Page {

  public newRegistration: NewRegistration;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private alertProvider: AlertProvider,
    private loadingCtrl: LoadingController,
    private authProvider: AuthProvider,
    private validatorProvider: ValidatorProvider,
    private newRegistrationProvider: NewRegistrationProvider,
  ) {
    this.newRegistration = new NewRegistration();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad NewRegistrationStep1Page');
  }

  ionViewWillEnter() {
    let that = this;

    this.newRegistrationProvider.loadAtVerificationPage(NewRegistrationStep2Page).subscribe((data: any) => {
      if (data) {
        that.newRegistration = data;
      }
    }, (error: any) => {
      console.log(error);
    });
  }

  onBack() {
    // this.newRegistrationProvider.saveDataAndGoToPage(this.newRegistration, -1);
    this.navCtrl.pop({
      animation: 'ios-transition'
    });
  }

  doVerify() {
    if (this.validatorProvider.isEmpty(this.newRegistration.email)) {
      this.alertProvider.doAlert('Forneça seu e-mail.', 'Atenção');
    } else if (!this.validatorProvider.isEmail(this.newRegistration.email)) {
      this.alertProvider.doAlert('Forneça um e-mail válido.', 'Atenção');
    } else if (this.validatorProvider.isEmpty(this.newRegistration.federalCode)) {
      this.alertProvider.doAlert('Forneça seu CPF.', 'Atenção');
    } else if (!this.validatorProvider.isCpf(this.newRegistration.federalCode)) {
      this.alertProvider.doAlert('Forneça um CPF válido.', 'Atenção');
    } else {
      let that = this;

      this.newRegistrationProvider.doVerification(this.newRegistration).subscribe((data: any) => {
        console.log('Retorno da verificacao: ', data);

        if ((data == null) || (data.length == 0)) {

          that.newRegistrationProvider.saveDataAndGoToPage(that.newRegistration,
            NewRegistrationStep2Page);

        } else {

          that.navCtrl.push(NewRegistrationExistsPage, {
            emails: data
          }, {
              animation: 'ios-transition'
            });

        }

      }, (error: any) => {
        console.log(error);
        that.newRegistrationProvider.saveDataAndGoToPage(that.newRegistration,
          NewRegistrationStep2Page);
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/new-registration-step1/new-registration-step1.ts